module.exports = __webpack_public_path__ + "img/Weapon_70.fd3072c2.png";